/** Alte Schrittnamen der Kampagne → Namen des Ablauf-Builders (wie im Statistik-Diagramm). */
export const LEGACY_STEP_TO_FLOW_FUNCTION: Record<string, string> = {
  send_connection_request: 'sendConnectionRequest',
  send_message: 'sendMail',
  send_inmail: 'sendInMail',
  send_email: 'sendEmail',
  visit_profile: 'visitProfile',
  check_reply: 'checkReply',
  wait: 'waitStep',
};
